import { CarouselFeature } from "./feature-base.js";
let touchMode = false;
class TouchModeDetectionFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    /** Hide control buttons in touch mode */
    this.enableTouchMode = () => {
      touchMode = true;
      if (!this.host.controls.overflow)
        this.host.controls.remove();
      this.host.addEventListener("pointerdown", this.disableTouchMode, {
        passive: true
      });
    };
    // Touch screen displays may accidentally trigger touch mode behaviour. Reenable in this case.
    this.disableTouchMode = (ev) => {
      if (ev.pointerType === "touch")
        return;
      this.host.shadow.append(this.host.controls);
      this.host.removeEventListener("pointerdown", this.disableTouchMode);
      touchMode = false;
    };
  }
  connectedCallback() {
    if (touchMode === true)
      return this.enableTouchMode();
    if (typeof window !== "undefined")
      window.addEventListener("touchstart", this.enableTouchMode, {
        once: true,
        passive: true
      });
  }
  disconnectedCallback() {
    if (typeof window !== "undefined")
      window.removeEventListener("touchstart", this.enableTouchMode);
    this.host.removeEventListener("pointerdown", this.disableTouchMode);
  }
}
export {
  TouchModeDetectionFeature
};
